module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Credit-card-525e76d48dacd4d5ddc93e9956267fbc.svg";